import { createSlice } from "@reduxjs/toolkit";
import { merge } from "common/helpers";

const initialState = { app: { active: "dashboard" } };

const navigationSlice = createSlice({
	name: "navigation",
	initialState,
	reducers: {
		setAppNavigation: (state, action) => {
			state.app = merge({
				dicts: [state.app, action.payload || {}],
				onlyCommonKeys: true,
			});
		},
	},
});

const getAppNavigation = (state) => state.navigation.app;

export { getAppNavigation };

export default navigationSlice;
